import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/user.model';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { UserVirtualOffice } from '../models/user-virtual-office.model';
import { RequestNovelty } from '../models/request.model';
import { NovedadesList } from '../models/novedades.model';
import { BeneficiariosList } from '../models/beneficiarios.model';
import { ConsultaList } from '../models/consultas.model';
import { ReceptorPDF } from '../models/receptorPdf.module';
import { RequestFile } from '../models/request-file-radication.model';
import { dataPDF } from '../models/dataPDF.model';
import { ListaSoportesNovedades } from '../models/lista-soportes-de-novedades.model';
import { SupportFilesOfRequest } from '../models/support-files-of-request.model';
import { RequestFileLoad } from '../models/request-file-load.model';

@Injectable()
export class UserService{

    constructor(
        private http: HttpClient,
        private api: ApiConfig    
    ){}

    isUpdateData(user :User) : Observable<boolean>{
        return this.http.post<boolean>(this.api.url + '/users/contracttype', user);
    }

    getDataUser(contract : string, identificacion : string) : Observable<User>{
        return this.http.get(this.api.url + '/users/' + contract + '/' + identificacion);
    }  

    getDataUserForContract(email : string, contract : string) : Observable<User>{
        return this.http.get(this.api.url + '/users/' + email + '/contract/' + contract);
    }

    getAfiliados(dato : string, dato2: string, tipo : number, identificacion : string, contratorDocumentType : string) : Observable<Array<User>>{
        return this.http.get<Array<User>>(this.api.url + '/users/' + dato + '/' + dato2 + '/' + tipo + '/' + identificacion + '/' + contratorDocumentType);
    }

    getStatusUser(identificacion : string) : Observable<any>{
        return this.http.get<any>(this.api.url + '/users/userState/' + identificacion );
    }

    getStatusUserPanacea(identificacion : string) : Observable<any>{
        return this.http.get<any>(this.api.url + '/users/userState/panacea/' + identificacion );
    }

    postGrabaHistoricoDatos(user: User) : Observable<any>{
        return this.http.post<any>(this.api.url + '/users', user);
    }

    postActualizaDatos(user: User) : Observable<any>{
        return this.http.post<any>(this.api.url + '/users/update', user);
    }

    getUserVirtualOffice(contract : string, identificacion : string, mail : string, apellidos : string, nombre : string) : Observable<Array<UserVirtualOffice>>{
        return this.http.get<Array<UserVirtualOffice>>(this.api.url + '/users?cont=' + contract + '&id=' + identificacion + '&mail=' + mail + '&ape=' + apellidos + '&nom=' + nombre);
    }

    getUserInfoNewPass(identificacion: string, tipousuario: string, tipoidentificacion) : Observable<Array<User>>{
        return this.http.get<Array<User>>(this.api.url + '/users/infonewpass/' +identificacion + '/' + tipousuario + '/' + tipoidentificacion);
    }

    //Ubicacion de servicios temporal
    actualizacionAutorizaciones(data: RequestNovelty): Observable<any> {
        return this.http.post<any>(this.api.url+ '/request/actualizacionautorizacion', data);
    }

    listaDeNovedades(contract:string): Observable<Array<NovedadesList>>{
        return this.http.get<Array<NovedadesList>>(this.api.url + '/request/'+ contract);
    }

    obtenerListaSoportesDeNovedades(): Observable<Array<ListaSoportesNovedades>>{
        return this.http.get<Array<ListaSoportesNovedades>>(this.api.url + '/request/soportes');
    }

    numeroDeRadicado(contrac:string, concept:string,user:string): Observable<any>{
        return this.http.get<any>(this.api.url + '/request/'+contrac+"/"+concept+"/"+user);
    }

    listaBeneficiarios(contrac:string):Observable<Array<BeneficiariosList>>{
        return this.http.get<Array<BeneficiariosList>>(this.api.url + '/request/beneficiarios/'+ contrac);
    }

    listaConsulta(contrac:string):Observable<Array<ConsultaList>>{
        return this.http.get<Array<ConsultaList>>(this.api.url + '/request/consulta/'+ contrac);
    }

    enviarArchivo(contrato: string
        , documentoUsuario: string
        , numeroRadicado: string
        , nombreNovedad: string
        , nombreSoporte: string
        , archivo: RequestFileLoad) : Observable <boolean> {
        return this.http.post<any>(this.api.url + '/request/uploadfile', {contrato, documentoUsuario, numeroRadicado, nombreNovedad, nombreSoporte, archivo});
    }

    envioPDF(data: dataPDF): Observable<any>{
        return this.http.post<any>(this.api.url + '/request/pdf',data)
    }
    
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/user.service.ts